import Loader from '@shared/components/Loader';
import {RootState} from '@store';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router';

import AppContainer from './App.style';
import AppRoutes from './routes';

export default function App() {
  const {pathname} = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.cssText = 'zoom: 100%';

    // Clean up the style on component unmount
    return () => {
      document.body.style.cssText = '';
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (pathname === '/') {
      navigate('/admin');
    }
  }, [pathname]);

  const {
    loader: {isAppLoading},
  } = useSelector((state: RootState) => state);
  return (
    <AppContainer>
      <AppRoutes />
      {isAppLoading && <Loader />}
    </AppContainer>
  );
}
